<template>
    <Form :model="FormInlineRole"
          :rules="RuleValidate"
          ref="RoleValidate"
          :label-width="110"
          style="text-align: left">
        <FormItem label="选择户主" prop="SelectRole">
            <Select v-model="FormInlineRole.SelectRole" @on-change="ChangeRole" :disabled="RoleDisabled">
                <Option v-for="(item,index) in RoleList" :value="item.ThirdID" :key="index">{{ item.S_Name }}</Option>
                <!--<Option v-for="item in FormInlineRole.RolesDisabled" :value="item.ThirdID" disabled>{{ item.S_Name }}</Option>-->
            </Select>
        </FormItem>
        <FormItem label="证件类型">
            <Input v-model="FormInlineRole.TypeSpecification" disabled="disabled" />
        </FormItem>
        <FormItem label="证件号">
            <Input v-model="FormInlineRole.S_IDNo" disabled="disabled" />
        </FormItem>
        <FormItem label="手机号码">
            <Input v-model="FormInlineRole.S_Mobile" disabled="disabled" />
        </FormItem>
    </Form>
</template>

<script>
    export default {
        name: "SelectRole",
        data(e){
            return {
                FormInlineRole:{
                    S_Name: '',
                    IdType: '',
                    S_IDNo: '',
                    S_Mobile:'',
                    TypeSpecification:"",
                    SelectRole: '',
                    Roles: [],
                    RolesDisabled:[],
                },
                RuleValidate: {
                    SelectRole:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormInlineRole.SelectRole){return callback(); }
                            else{return callback(new Error("户主不能为空"));}
                        } }],
                },
                RoleDisabled:false,
            }
        },
        computed: {
            RoleList() {
                return this.$store.state.GetSelectRole.Roles;
            }
        },
        created(){
            if(this.RoleList&&this.RoleList.length<=0){
                this.$store.commit("GetSelectRole",{_I_Type:2});
            }
        },
        mounted(){

        },
        destroyed(){
            //this.$store.state.GetSelectRole.Roles=[];
        },
        methods:{
            ChangeRole(item){
                let that=this;
                that.RoleList.forEach(function(n){
                    if(n.ThirdID==item){
                        that.FormInlineRole.S_IDNo=n.S_IDNo;
                        that.FormInlineRole.TypeSpecification=n.TypeSpecification;
                        that.FormInlineRole.S_Mobile=n.S_mobile;
                        that.$emit("currentRoleData", that.FormInlineRole.SelectRole);
                    }
                });
            },
            ValidateRole(){
                let that=this;
                let _res=false;
                that.$refs["RoleValidate"].validate((valid) => {
                    if (valid) {_res=true;}
                });
                return _res;
            }
        }
    }
</script>
